<div #modal [id]="getId()" class="modal fade" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header justify-content-center">
                <h3><i class="fa fa-shopping-cart"></i> Buch kaufen</h3>
            </div>
            <div class="modal-body">
                <span>Hier kannst du das Buch erwerben:</span>
                @if (applicationStateService.bookConfig.productLink) {
                    <div class="buy-block">
                        <p class="text-center fs-5">
                            <img [attr.src]="'sidebar-quicklinks/icon-kaufen-printbuch.png'|asset "/> Gedrucktes Schulbuch bestellen
                        </p>
                        <p class="text-center">
                            <a [href]="applicationStateService.bookConfig.productLink" class="btn btn-open btn-round" target="_blank">
                                zum BVL-Shop
                            </a>
                        </p>
                    </div>
                }
                @if (applicationStateService.bookConfig.storeLink) {
                    <div class="buy-block">
                        <p class="text-center fs-5">
                            <img [attr.src]="'sidebar-quicklinks/store-at-logo.png'|asset"/> Digi.Buch auf Store.at kaufen
                        </p>
                        <p class="text-center">
                            @if (applicationStateService.userData.bookAccessCode?.canUpgrade) {
                                <a [href]="getUpgradeRoute(applicationStateService.userData.bookAccessCode.quickLink)" class="btn btn-buy-store border-2 fw-bold" target="_blank">
                                    Upgrade auf Store.at kaufen <i class="fa fa-shopping-cart"></i>
                                </a>
                            } @else {
                                <a [href]="applicationStateService.bookConfig.storeLink" class="btn btn-buy-store border-2 fw-bold" target="_blank">
                                    auf Store.at kaufen <i class="fa fa-shopping-cart"></i>
                                </a>
                            }
                        </p>
                    </div>
                }
                @if (applicationStateService.userData.bookAccessCode) {
                    <div class="current-code">
                        <div>Info: Aktuell ist bereits ein Stickercode im Buch eingelöst:</div>
                        <div>
                            Stickercode: <b>{{ applicationStateService.userData.bookAccessCode.quickLink }}</b>
                            @if (applicationStateService.userData.bookAccessCode.pin) {
                                | PIN: <b>{{ applicationStateService.userData.bookAccessCode.pin }}</b>
                            }
                            | PLUS: <b>{{ accessService.isPlus(applicationStateService.userData.bookAccessCode.version) ? 'ja' : 'nein' }}</b>
                        </div>
                    </div>
                }
            </div>
            <div class="modal-footer platform justify-content-center">
                <button type="button" class="btn btn-link" data-bs-dismiss="modal" aria-label="Close">zurück zum Buch</button>
            </div>
        </div>
    </div>
</div>
